module.exports = __webpack_public_path__ + "static/media/darkGradient.cc96e7b8.svg";